import PropTypes from 'prop-types';
import React from 'react';
import { get, isEmpty, recursiveGet } from 'lodash';
import ClientSummary from '../ClientSummary';
import { CALLBACKS } from '../../api/config';
function RequestorHeader(props) {
  var goToFacesheet = function goToFacesheet() {
    var _props$screening = props.screening,
      screening = _props$screening === void 0 ? {} : _props$screening;
    if (get(screening, 'subject.id')) {
      CALLBACKS.goToFacesheet(get(screening, 'subject.id'));
    }
  };
  var contact = props.contact,
    screening = props.screening;
  var requestorOrContact = contact || recursiveGet(screening, ['contact', 'requestor'], function (cont) {
    return !isEmpty(cont);
  });
  var goToFacesheetLink = get(screening, 'subject.id') ? /*#__PURE__*/React.createElement("a", {
    className: "client-name__link",
    onClick: goToFacesheet,
    role: "link"
  }, "GO TO FACESHEET") : null;
  return /*#__PURE__*/React.createElement("div", {
    className: "requestor-header"
  }, /*#__PURE__*/React.createElement(ClientSummary, {
    contact: requestorOrContact
  }), /*#__PURE__*/React.createElement("div", {
    className: "pull-right"
  }, goToFacesheetLink));
}
RequestorHeader.propTypes = {
  contact: PropTypes.object,
  screening: PropTypes.shape({
    contact: PropTypes.object,
    requestor: PropTypes.object
  }).isRequired
};
RequestorHeader.defaultProps = {
  contact: {}
};
export default RequestorHeader;
//# sourceMappingURL=index.js.map